// V4.3 — frontend mirror of the quota caps enforced server-side in
// supabase/functions/_shared/v43Quotas.ts. Display-only (the backend is the
// source of truth for enforcement). Keep these numbers in sync with the edge
// constants.

export type PlanTier = "free" | "premium" | "pro" | "ultra";

const M = 60;

// TTS minutes/month per tier (BP V4.3): Free 3 · Premium 40 · Pro 70 · Ultra 130.
export const TTS_LIMITS_SECONDS: Record<PlanTier, number> = {
  free: 3 * M,
  premium: 40 * M,
  pro: 70 * M,
  ultra: 130 * M,
};

// Live (Conv AI) minutes/month per tier: Free 0 · Premium 5 · Pro 20 · Ultra 50.
export const LIVE_LIMITS_SECONDS: Record<PlanTier, number> = {
  free: 0 * M,
  premium: 5 * M,
  pro: 20 * M,
  ultra: 50 * M,
};

// Free text/AI message caps (paid tiers are uncapped on text).
export const FREE_MONTHLY_AI_MSG_CAP = 40;
export const FREE_DAILY_AI_MSG_CAP = 10;

export function ttsLimitFor(plan: PlanTier): number {
  return TTS_LIMITS_SECONDS[plan] ?? TTS_LIMITS_SECONDS.free;
}

export function isFreeTier(plan: PlanTier): boolean {
  return plan === "free";
}
